/** Current wordstr application version. Update this on every release. */
export const APP_VERSION = '1.12.0';
